import CheckedIcon from "@mui/icons-material/Check";
import UncheckedIcon from "@mui/icons-material/Clear";
import DetailsIcon from "@mui/icons-material/Details";
import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { startOfDay } from "date-fns";

import { formatIsoDateString } from "../../utils/helpers";
import OmniAvatar from "./omniAvatar";
import OmniListItemButton from "./omniListItemButton";

const OmniCommunicationRequestResultsListItem = props => {
  const {
    communicationRequestResultsDef,
    onClickHandler = null,
    onNavigateHandler = null,
    isTypeSupported = false,
  } = props;
  const theme = useTheme();

  const getSelectedIcon = status => {
    if (status === "success") {
      return <CheckedIcon />;
    } else {
      return <UncheckedIcon />;
    }
  };

  const scopeLinkToCorrectDate = () => {
    let url = communicationRequestResultsDef.omniData.dashboard_url;
    let newStartDate = startOfDay(new Date(communicationRequestResultsDef.omniData.startTime))
      .toISOString()
      .replaceAll(":", "*3a");
    let newEndDate = new Date().toISOString().replaceAll(":", "*3a");

    let newValue = newStartDate + "~end~'" + newEndDate;

    let startPattern = "~start~'";
    let endPattern = ")&query";

    let startIndex = url.indexOf(startPattern);
    let endIndex = url.indexOf(endPattern, startIndex);

    if (startIndex === -1 || endIndex === -1) {
      console.error("Patterns not found in the URL");
      return url;
    }

    let beforeStart = url.substring(0, startIndex + startPattern.length);
    let afterEnd = url.substring(endIndex);

    return beforeStart + newValue + afterEnd;
  };

  return (
    <ListItem
      disableGutters={true}
      sx={{
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        backgroundColor:
          isTypeSupported || communicationRequestResultsDef.omniData.status === "success"
            ? theme.palette.success.main
            : theme.palette.info.main,
        color: theme.palette.info.contrastText,
        cursor: "pointer",
        boxShadow: theme.shadows[3],
        userSelect: "none",
        webkitUserSelect: "none",
      }}
      onClick={e => {
        e.stopPropagation();
        if (onClickHandler) {
          onClickHandler();
        }
        window.open(scopeLinkToCorrectDate(), "_blank", "noreferrer");
      }}
    >
      <Tooltip title={"Click to Toggle"} placement="right">
        <OmniAvatar
          sx={{
            width: 36,
            height: 36,
            fontSize: "1.2rem",
            backgroundColor:
              isTypeSupported || communicationRequestResultsDef.omniData.status === "success"
                ? theme.palette.success.main
                : theme.palette.info.main,
            border: `2px solid ${theme.palette.info.contrastText}`,
          }}
        >
          {getSelectedIcon(communicationRequestResultsDef.omniData.status)}
        </OmniAvatar>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
              textTransform: "capitalize",
            }}
          >
            {formatIsoDateString(communicationRequestResultsDef.omniData.startTime)} -{" "}
            {communicationRequestResultsDef.omniData.status}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
            }}
          >
            Duration: {communicationRequestResultsDef.omniData.sendingDuration.toFixed(1)} seconds
          </Typography>
        }
      />
      {onNavigateHandler && (
        <OmniListItemButton
          title={"Check Status"}
          sx={{
            marginTop: "1px",
            marginRight: "1px",
          }}
          size="large"
          onClick={e => {
            e.stopPropagation();
            //  window.location.reload();
            //todo ImplmentNavigation
          }}
          icon={<DetailsIcon />}
        />
      )}
    </ListItem>
    // </Link>
  );
};

export default OmniCommunicationRequestResultsListItem;
